import { domain } from 'modules/data';

export const documentPerFileMaxSize: { [key in domain.IntegrationType]?: number } = {
    [domain.IntegrationType.Xero]: 10 * 1000 * 1000,
    [domain.IntegrationType.QBooks]: 20 * 1024 * 1024,
    [domain.IntegrationType.NetSuite]: 10 * 1024 * 1024,
};

export const documentPerPageMaxSize = 25 * 1024 * 1024;
